const DocumentTypeKey = {
  RUT_BACK: 'RUT_BACK',
  RUT_FRONT: 'RUT_FRONT',
  EMPOWERED_TO_SIGN_POWER: 'EMPOWERED_TO_SIGN_POWER',
  OPERATIONS_VALIDATION_ITEM: 'OPERATIONS_VALIDATION_ITEM',
  OPERATIONS_VALIDATION_EVIDENCE: 'OPERATIONS_VALIDATION_EVIDENCE',
  COMPLIANCE_VALIDATION_ITEM: 'COMPLIANCE_VALIDATION_ITEM',
  COMPLIANCE_VALIDATION_EVIDENCE: 'COMPLIANCE_VALIDATION_EVIDENCE',
  COMPLIANCE_VALIDATION_EXTRAS: 'COMPLIANCE_VALIDATION_EXTRAS',
  CI_DOCUMENT: 'CI_DOCUMENT',
  SOCIETY_CONSTITUTION_COPY: 'SOCIETY_CONSTITUTION_COPY',
  OFICIAL_JOURNAL_EXTRACT: 'OFICIAL_JOURNAL_EXTRACT',
  SOCIAL_INSCRIPTION: 'SOCIAL_INSCRIPTION',
  SUBSEQUENT_CONSTITUTION_MODIFICATIONS: 'SUBSEQUENT_MODIFICATIONS',
  POWER: 'POWER',
  SOCIETY_RUT: 'SOCIETY_RUT',
  OTHER_DOCUMENTS: 'OTHER_DOCUMENTS',
  LEGAL_REPRESENTATIVE_CI: 'LEGAL_REPRESENTATIVE_CI',
  MANDATARY_PERSON_POWER: 'MANDATARY_PERSON_POWER',
  AUTHORIZED_TO_GIVE_INSTRUCTION_POWER: 'AUTHORIZED_TO_GIVE_INSTRUCTION_POWER',
};

export default DocumentTypeKey;
